import { render, staticRenderFns } from "./TechEvalItemExpand.vue?vue&type=template&id=dcf8f8cc&scoped=true&"
import script from "./TechEvalItemExpand.vue?vue&type=script&lang=js&"
export * from "./TechEvalItemExpand.vue?vue&type=script&lang=js&"
import style0 from "./TechEvalItemExpand.vue?vue&type=style&index=0&id=dcf8f8cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf8f8cc",
  null
  
)

export default component.exports